var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-card-text",
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "6" } },
                [
                  _c("v-text-field", {
                    ref: "codigo_comercio",
                    attrs: {
                      label: "Codigo_Comercio",
                      "prepend-inner-icon": "mdi-account-tie",
                      required: "",
                    },
                    model: {
                      value: _vm.dataTef.codigo_comercio,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataTef, "codigo_comercio", $$v)
                      },
                      expression: "dataTef.codigo_comercio",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "6" } },
                [
                  _c("v-text-field", {
                    ref: "codigo_terminal",
                    attrs: {
                      label: "Codigo_Terminal",
                      "prepend-inner-icon": "mdi-account-tie",
                      required: "",
                    },
                    model: {
                      value: _vm.dataTef.codigo_terminal,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataTef, "codigo_terminal", $$v)
                      },
                      expression: "dataTef.codigo_terminal",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "justify-end" },
            [
              _c(
                "v-btn",
                {
                  staticStyle: {
                    "background-color": "rgb(204 33 40)",
                    color: "white !important",
                  },
                  attrs: { text: "" },
                  on: {
                    click: function ($event) {
                      return _vm.updateDataTef()
                    },
                  },
                },
                [_vm._v(" Actualizar ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }